import Vue from 'vue'

Vue.prototype.$qqEmoji = (str: string) => {
  return setQQEmoji(str);
};

const resource = [
  {
    "name": "[微笑]",
    "pic": "qqEmoji_0.png"
  },
  {
    "name": "[撇嘴]",
    "pic": "qqEmoji_1.png"
  },
  {
    "name": "[色]",
    "pic": "qqEmoji_2.png"
  },
  {
    "name": "[发呆]",
    "pic": "qqEmoji_3.png"
  },
  {
    "name": "[得意]",
    "pic": "qqEmoji_4.png"
  },
  {
    "name": "[流泪]",
    "pic": "qqEmoji_5.png"
  },
  {
    "name": "[害羞]",
    "pic": "qqEmoji_6.png"
  },
  {
    "name": "[闭嘴]",
    "pic": "qqEmoji_7.png"
  },
  {
    "name": "[睡]",
    "pic": "qqEmoji_8.png"
  },
  {
    "name": "[大哭]",
    "pic": "qqEmoji_9.png"
  },
  {
    "name": "[尴尬]",
    "pic": "qqEmoji_10.png"
  },
  {
    "name": "[调皮]",
    "pic": "qqEmoji_12.png"
  },
  {
    "name": "[龇牙]",
    "pic": "qqEmoji_13.png"
  },
  {
    "name": "[难过]",
    "pic": "qqEmoji_15.png"
  },
  {
    "name": "[酷]",
    "pic": "qqEmoji_16.png"
  },
  {
    "name": "[冷汗]",
    "pic": "qqEmoji_17.png"
  },
  {
    "name": "[吐]",
    "pic": "qqEmoji_19.png"
  },
  {
    "name": "[偷笑]",
    "pic": "qqEmoji_20.png"
  },
  {
    "name": "[惊讶]",
    "pic": "qqEmoji_18.png"
  },
  {
    "name": "[可爱]",
    "pic": "qqEmoji_21.png"
  },
  {
    "name": "[白眼]",
    "pic": "qqEmoji_22.png"
  },
  {
    "name": "[饥饿]",
    "pic": "qqEmoji_24.png"
  },
  {
    "name": "[困]",
    "pic": "qqEmoji_25.png"
  },
  {
    "name": "[流汗]",
    "pic": "qqEmoji_27.png"
  },
  {
    "name": "[憨笑]",
    "pic": "qqEmoji_28.png"
  },
  {
    "name": "[大兵]",
    "pic": "qqEmoji_29.png"
  },
  {
    "name": "[奋斗]",
    "pic": "qqEmoji_30.png"
  },
  {
    "name": "[疑问]",
    "pic": "qqEmoji_32.png"
  },
  {
    "name": "[嘘…]",
    "pic": "qqEmoji_33.png"
  },
  {
    "name": "[晕]",
    "pic": "qqEmoji_34.png"
  },
  {
    "name": "[衰]",
    "pic": "qqEmoji_36.png"
  },
  {
    "name": "[再见]",
    "pic": "qqEmoji_39.png"
  },
  {
    "name": "[擦汗]",
    "pic": "qqEmoji_40.png"
  },
  {
    "name": "[抠鼻]",
    "pic": "qqEmoji_41.png"
  },
  {
    "name": "[鼓掌]",
    "pic": "qqEmoji_42.png"
  },
  {
    "name": "[糗大了]",
    "pic": "qqEmoji_43.png"
  },
  {
    "name": "[坏笑]",
    "pic": "qqEmoji_44.png"
  },
  {
    "name": "[左哼哼]",
    "pic": "qqEmoji_45.png"
  },
  {
    "name": "[右哼哼]",
    "pic": "qqEmoji_46.png"
  },
  {
    "name": "[哈欠]",
    "pic": "qqEmoji_47.png"
  },
  {
    "name": "[委屈]",
    "pic": "qqEmoji_49.png"
  },
  {
    "name": "[快哭了]",
    "pic": "qqEmoji_50.png"
  },
  {
    "name": "[阴险]",
    "pic": "qqEmoji_51.png"
  },
  {
    "name": "[亲亲]",
    "pic": "qqEmoji_52.png"
  },
  {
    "name": "[可怜]",
    "pic": "qqEmoji_54.png"
  },
  {
    "name": "[西瓜]",
    "pic": "qqEmoji_56.png"
  },
  {
    "name": "[啤酒]",
    "pic": "qqEmoji_57.png"
  },
  {
    "name": "[篮球]",
    "pic": "qqEmoji_58.png"
  },
  {
    "name": "[乒乓球]",
    "pic": "qqEmoji_59.png"
  },
  {
    "name": "[咖啡]",
    "pic": "qqEmoji_60.png"
  },
  {
    "name": "[饭]",
    "pic": "qqEmoji_61.png"
  },
  {
    "name": "[玫瑰]",
    "pic": "qqEmoji_63.png"
  },
  {
    "name": "[凋谢]",
    "pic": "qqEmoji_64.png"
  },
  {
    "name": "[示爱]",
    "pic": "qqEmoji_65.png"
  },
  {
    "name": "[爱心]",
    "pic": "qqEmoji_66.png"
  },
  {
    "name": "[心碎]",
    "pic": "qqEmoji_67.png"
  },
  {
    "name": "[蛋糕]",
    "pic": "qqEmoji_68.png"
  },
  {
    "name": "[足球]",
    "pic": "qqEmoji_72.png"
  },
  {
    "name": "[瓢虫]",
    "pic": "qqEmoji_73.png"
  },
  {
    "name": "[月亮]",
    "pic": "qqEmoji_75.png"
  },
  {
    "name": "[太阳]",
    "pic": "qqEmoji_76.png"
  },
  {
    "name": "[礼物]",
    "pic": "qqEmoji_77.png"
  },
  {
    "name": "[拥抱]",
    "pic": "qqEmoji_78.png"
  },
  {
    "name": "[强]",
    "pic": "qqEmoji_79.png"
  },
  {
    "name": "[握手]",
    "pic": "qqEmoji_81.png"
  },
  {
    "name": "[胜利]",
    "pic": "qqEmoji_82.png"
  },
  {
    "name": "[抱拳]",
    "pic": "qqEmoji_83.png"
  },
  {
    "name": "[拳头]",
    "pic": "qqEmoji_85.png"
  },
  {
    "name": "[爱你]",
    "pic": "qqEmoji_87.png"
  },
  {
    "name": "[NO]",
    "pic": "qqEmoji_88.png"
  },
  {
    "name": "[OK]",
    "pic": "qqEmoji_89.png"
  },
  {
    "name": "[爱情]",
    "pic": "qqEmoji_90.png"
  },
  {
    "name": "[飞吻]",
    "pic": "qqEmoji_91.png"
  },
  {
    "name": "[跳跳]",
    "pic": "qqEmoji_92.png"
  },
  {
    "name": "[发抖]",
    "pic": "qqEmoji_93.png"
  },
  {
    "name": "[怄火]",
    "pic": "qqEmoji_94.png"
  },
  {
    "name": "[转圈]",
    "pic": "qqEmoji_95.png"
  },
  {
    "name": "[磕头]",
    "pic": "qqEmoji_96.png"
  },
  {
    "name": "[回头]",
    "pic": "qqEmoji_97.png"
  },
  {
    "name": "[跳绳]",
    "pic": "qqEmoji_98.png"
  },
  {
    "name": "[挥手]",
    "pic": "qqEmoji_99.png"
  }
]

const hostUrl = 'https://f.diyiedu.com/qq_emoji';

function setQQEmoji(str: string) {
  let newStr = str;
  const arr: any[] | null = str.match(/\[.*?\]/g);
  arr && arr.forEach((name: any, index) => {
    try {
      resource.forEach((resourceItem) => {
        if (resourceItem.name === name) {
          const emoji = `<img src="${hostUrl}/${resourceItem.pic}" class="qq_emoji">`;
          newStr = newStr.replace(name, emoji);
          throw '';
        }
      })
    } catch (e) {
      //
    }
  })
  return newStr;
}